// extracted by mini-css-extract-plugin
export default {"item":"ListSkeleton_item__KOqjX","shimmer":"ListSkeleton_shimmer__APTM9"};